<template>
  <div id="home">
    <!-- <img src="../assets/logo.png"> -->
    <Header></Header>
    <Navi currentPage="" id="navi" :naviHeight="naviH"></Navi>
    <Homeintro id="main"></Homeintro>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from '@/components/header.vue'
import Navi from '@/components/navigate.vue'
import Footer from '@/components/footer.vue'
import Homeintro from '@/components/home_intro.vue'

export default {
  name: 'home',
  components: {Navi,Footer,Homeintro,Header},
  mounted(){
    this.getHeigth()
  },
  data(){
    return{
      naviH:'500px'
    }
  },
  methods:{
    getHeigth(){
      var h = document.getElementById('main').clientHeight;
      console.log(h);
      if (h<400){
          h=400
      }
      this.naviH=h+'px'
      // document.getElementById('main').style.height=this.naviH
    }
  }

}

</script>

<style scoped>
.home_intro{
  position: relative;
  top:85px;
  bottom: 10px;
  left: 205px;
}
</style>


// WEBPACK FOOTER //
// src/views/home.vue